import { Box, Button, Grid2 } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Fragment } from 'react/jsx-runtime';
import { ReactComponent as ProjectIcon } from '../../../assets/icons/project-icon.svg';
import { closeDialog } from '../../../store/dialog/dialog.action';
import {
    clearNodeSelected,
    getMyNodesStart,
} from '../../../store/node/node.action';
import {
    clearNodeProjectSelected,
    clearProjectSelected,
    getMyProjectsStart,
    getProjectStart,
} from '../../../store/project/project.action';
import { selectMyProjects } from '../../../store/project/project.selector';
import DialogActions from '../../ui/dialog-actions/dialog-actions.component';
import DialogContent from '../../ui/dialog-content/dialog-content.component';
import DialogTitle from '../../ui/dialog-title/dialog-title.component';
import {
    ProjectCard,
    ProjectCardIcon,
    ProjectCardTitle,
} from './dialog-select-project.styles';

const DialogSelectProject = () => {
    const dispatch = useDispatch();

    const myProjects = useSelector(selectMyProjects);

    const handleGoMyNodes = () => {
        dispatch(closeDialog());
        dispatch(clearProjectSelected());
        dispatch(clearNodeProjectSelected());
        dispatch(clearNodeSelected());
        dispatch(getMyNodesStart(null));
    };

    const handleGoToProject = (projectId: number) => {
        dispatch(closeDialog());
        dispatch(clearNodeSelected());
        dispatch(clearNodeProjectSelected());
        dispatch(getProjectStart(projectId, null));
        dispatch(getMyNodesStart(projectId));
    };

    useEffect(() => {
        dispatch(getMyProjectsStart());
    }, [dispatch]);

    return (
        <Fragment>
            <DialogTitle title="I progetti" />
            <DialogContent>
                <Grid2 width={'100%'} container spacing={2}>
                    {myProjects.map((project) => (
                        <Grid2 size={4} key={project.id}>
                            <ProjectCard
                                key={project.id}
                                onClick={() => handleGoToProject(project.id)}
                            >
                                <Box
                                    display={'flex'}
                                    gap={2}
                                    alignItems={'center'}
                                    height={'100%'}
                                    pr={2}
                                >
                                    <ProjectCardIcon>
                                        <ProjectIcon />
                                    </ProjectCardIcon>
                                    <ProjectCardTitle>
                                        {project.name}
                                    </ProjectCardTitle>
                                </Box>
                            </ProjectCard>
                        </Grid2>
                    ))}
                </Grid2>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={handleGoMyNodes}
                    style={{
                        borderRadius: '15px',
                        background: '#59B8CA',
                        width: '220px',
                        height: '40px',
                        flexShrink: 0,
                        color: '#2C375A',
                        border: 'none',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: '14px',
                    }}
                >
                    TORNA ALLE MIE ATTIVITA'
                </Button>
            </DialogActions>
        </Fragment>
    );
};

export default DialogSelectProject;
